export const INVOICE_LIST_ROUTE = '/private/invoices';

export const ADD_INVOICE_ROUTE = '/private/addinvoice';

export const ADD_BUSINESS_ROUTE = '/private/addbusiness';

export const BILLING_ROUTE = '/private/billing';

export const ACCOUNT_ROUTE = '/private/account';

export const CLIENT_LIST_ROUTE = '/private/clients';

export const LOGIN_ROUTE = '/';

export const SIGNUP_ROUTE = '/signup';

export const DASHBOARD_ROUTE = '/private/dashboard';

export const BUSINESS_SETTINGS_ROUTE = '/private/business';

export const ESTIMATE_LIST_ROUTE = '/private/estimates';

export const ADD_ESTIMATE_ROUTE = '/private/addestimate';

export const EMAIL_LIST_ROUTE = '/private/emails';
